module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/writable-browser.js
// module id = 1263
// module chunks = 0